import { datadogRum } from '@datadog/browser-rum'

import { APP_VERSION, SENTRY_ENVIRONMENT } from './constants'

// Only initialize RUM in production and over HTTPS (required for partitioned cookies)
if (process.env.NODE_ENV === 'production' && location.protocol === 'https:') {
  datadogRum.init({
    applicationId: '2f0e5e76-569d-4c3a-947b-3e5b083476e2',
    clientToken: 'pub8310a88dd926b95607164d3eaac7678e',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'intelibly-request',
    env: SENTRY_ENVIRONMENT,
    version: APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 1,
    defaultPrivacyLevel: 'mask-user-input',
    // --- iframe/session fixes ---
    usePartitionedCrossSiteSessionCookie: true,
    sessionPersistence: 'cookie',
    allowFallbackToLocalStorage: true,
    trackViewsManually: true,
  })

  // Debug log for iframe session cookie (suppressed in production builds)
  console.debug('Datadog RUM: Using partitioned cross-site session cookie for iframe compatibility')

  // Runtime verification: check if session cookie was created
  setTimeout(() => {
    const hasDatadogCookie = document.cookie.includes('_dd_s') || document.cookie.includes('_dd_r')
    if (!hasDatadogCookie) {
      console.warn('Datadog RUM: Session cookie not detected. Iframe sandbox restrictions may be blocking cookie access.')
    }
  }, 1000)
}
